import { ChangeEvent, FormEvent, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import avatarDefaultImg from '../../assets/img/avatarDefault.png';
import confirmacaoImg from '../../assets/img/confirmacao.png';
import erroImg from '../../assets/img/erroFechar.png';
import { ModalEstadoContext } from '../../contexts/ModalEstado';
import { cepMascara, descriptografarDado, telefoneMascara } from '../../helpers';
import { organizacaoDados } from '../../interfaces/organizacao';
import Permissoes from '../../middleware/Permissoes';
import buscarCep from '../../services/cep';
import { atualizarAvatarOrganizacao, atualizarOrganizacao, dadosOrganizacao } from '../../services/organizacao';
import LoagindBarra from '../LoadingBarra';
import ModalAlerta from '../ModalAlerta';
import ModalContratarSistema from '../ModalContratarSistema';
import { Button, Loader } from '../Styles';
import './dadosorganizacao.css';

const DadosOrganizacao = () => {

    const { exibirModal, modalEstado, atualizarInformacoes, atualizarDados } = useContext(ModalEstadoContext)

    const [organizacao, setOrganizacao] = useState<organizacaoDados>()
    const [cnpjCpf, setCnpjCpf] = useState('')
    const [nomeFantasia, setNomeFantasia] = useState<string | null>(null)
    const [razaoSocial, setRazaoSocial] = useState<string | null>(null)
    const [email, setEmail] = useState<string | null>(null)
    const [telefone, setTelefone] = useState<string | null>(null)
    const [rua, setRua] = useState<string | null>(null)
    const [numero, setNumero] = useState<string | null>(null)
    const [bairro, setBairro] = useState<string | null>(null)
    const [complemento, setComplemento] = useState<string | null>(null)
    const [cep, setCep] = useState<string | null>(null)
    const [cidade, setCidade] = useState<string | null>(null)
    const [estado, setEstado] = useState<string | null>(null)
    const [avatar, setAvatar] = useState<File>()
    const [site, setSite] = useState<string | null>(null)
    const [modalContratar, setModalContrar] = useState(false)
    const [processando, setProcessando] = useState(false)
    const [confirmacao, setConfirmacao] = useState(false)
    const [erro, setErro] = useState(false)

    const ocultarModalAlerta = () => {

        setErro(false)
        setConfirmacao(false)

        return
    }

    const maisUsuario = () => {
        return alert('Acesse o Menu Suporte > Solicitar Atendimento. Informa na descrição da solicitação a quantidade de usuários adicionais que deseja. Esteja ciente que ao ser concluído o atendimento, sua assinatura será atualizada aumentando em R$ 9,90 por cada usuário adicional')
    }

    const exibirModalContratarSistema = () => exibirModal()

    const changeTelefone = (e: ChangeEvent<HTMLInputElement>) => {

        return setTelefone(telefoneMascara(e.target.value))
    }

    const changeCep = async (e: ChangeEvent<HTMLInputElement>) => {

        const valor = cepMascara(e.target.value)
        setCep(valor)

        const cepLimpo = valor.replace(/\D/g, "")

        if (cepLimpo.length !== 8) return

        try {

            const dados = await toast.promise(buscarCep(valor), {
                pending: "Buscando dados do endereço, por favor aguarde...",
                error: "CEP inválido"
            })

            setRua(dados.logradouro)
            setBairro(dados.bairro)
            setCidade(dados.localidade)
            setEstado(dados.estado.toLowerCase())

        } catch (error) {

            toast.error("CEP inválido")
            setRua("")
            setBairro("")
            setCidade("")
            setEstado("")
        }
    }

    const avatarFile = (e: any) => {

        const arquivo = e.target.files[0]

        if (arquivo) {
            const extensaoPermitida = ['.png', '.jpeg', '.jpg']
            const extensaoArquivo = arquivo.name.split('.').pop().toLowerCase()

            if (extensaoPermitida.includes(`.${extensaoArquivo}`)) {
                return setAvatar(arquivo)
            } else {
                return alert('Tipo de Arquivo não Permitido. Escolha uma imagem')
            }
        } else {
            setAvatar(undefined)
        }
    }

    const atualizarDadosOrganizacao = async (e: FormEvent) => {

        e.preventDefault()
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'configuracao_empresa']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if (!temPermissao) return toast.warn("Você não tem permissão para atualizar os dados cadastrais da Empresa.")
        setProcessando(true)

        const payload = {
            nomeFantasia,
            razaoSocial,
            email,
            telefone,
            site,
            numero,
            complemento,
            cep,
            rua,
            bairro,
            cidade,
            estado
        }

        try {
            const resposta = await atualizarOrganizacao(payload)

            if (resposta.status === 200) {
                atualizarDados()
                setProcessando(false)
                setConfirmacao(true)
            }
        } catch (error: any) {
            setProcessando(false)
            return setErro(true)
        }
    }

    const atualizarAvatar = async (e: FormEvent) => {

        e.preventDefault()
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'configuracao_empresa']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if (!temPermissao) return toast.warn("Você não tem permissão para atualizar o avatar da Empresa.")
        setProcessando(true)

        if (avatar === undefined) {
            return setProcessando(false)
        }

        const payload = {
            avatar
        }

        try {

            const resposta = await atualizarAvatarOrganizacao(payload)

            if (resposta.status === 200) {
                setProcessando(false)
                atualizarDados()
                setConfirmacao(true)
            }

        } catch (error) {

            setProcessando(false)
            return setErro(true)

        }
    }

    useEffect(() => {
        setModalContrar(modalEstado)
    }, [modalEstado])

    useEffect(() => {

        const fetchOrganizacao = async () => {

            setProcessando(true)

            try {

                const resposta = await dadosOrganizacao()

                if (resposta.status === 200) {
                    const { data } = resposta

                    setCnpjCpf(data.cnpjCpf)
                    setNomeFantasia(data.nomeFantasia)
                    setRazaoSocial(data.razaoSocial)
                    setEmail(data.email)
                    setSite(data.site)
                    setTelefone(data.telefone)
                    setRua(data.rua)
                    setNumero(data.numero)
                    setBairro(data.bairro)
                    setComplemento(data.complemento)
                    setCep(data.cep)
                    setCidade(data.cidade)
                    setEstado(data.estado.toLowerCase())
                    setOrganizacao(data)
                }

            } catch (error) {

                console.error('Ocorreu um erro ao buscar a organização:', error)

            } finally {
                setProcessando(false)
            }
        }

        fetchOrganizacao()

    }, [atualizarInformacoes])

    return (
        <Permissoes permissoes={['master', 'administrativo', 'configuracao_empresa']}>
            <div id="dadosOrganizacaoContainer">
                {modalContratar && <ModalContratarSistema organizacao={organizacao} />}
                {processando && <LoagindBarra />}
                {confirmacao && <ModalAlerta icone={confirmacaoImg} texto='Dados atualizados com sucesso!' btnTitulo='Continuar' cor='continuarSucesso' acao={ocultarModalAlerta} />}
                {erro && <ModalAlerta icone={erroImg} texto='Fallha ao processar a solicitação. Gentileza tentar novamente!' btnTitulo='Continuar' cor='continuarErro' acao={ocultarModalAlerta} />}
                <section id='sectionDadosOrganizacaoHeard'>
                    {organizacao?.sistemaContratado === true && <span>
                        <p>Você tem <b>{organizacao.usuariosAdicionais?.toString().padStart(2, '0')}</b> usuários adicionais contratados</p>
                        <p>Sua Licença expira em <b>{organizacao.validadeLicenca.slice(8, 10)}-{organizacao.validadeLicenca.slice(5, 7)}-{organizacao.validadeLicenca.slice(0, 4)}</b></p>
                        <Button type='button' cor='solicitarUsuario' isLoading={processando} onClick={maisUsuario}>Solicitar Mais Usuários</Button>
                    </span>}
                    {organizacao?.sistemaContratado === false && <span>
                        <p>Seu período de teste encerra em <b>{organizacao.validadeLicenca.slice(8, 10)}/{organizacao.validadeLicenca.slice(5, 7)}/{organizacao.validadeLicenca.slice(0, 4)}</b></p>
                        <Button type='button' cor='solicitarUsuario' isLoading={processando} onClick={exibirModalContratarSistema}>Contratar Agora</Button>
                    </span>}
                    <span>
                        <img id="avatarUsuarioGesttor" src={avatarDefaultImg} alt="" />
                    </span>
                </section>
                <section className='containerDadosOrhanizacao'>
                    <span className='avatarOrganizacao'>
                        {organizacao?.avatar ? <img src={organizacao.avatar} alt='Logo da Empresa' /> : null}
                        <form onSubmit={atualizarAvatar}>
                            <div className='formAtualizarAvatar'>
                                <label htmlFor="avatarAtualizarOrganizacao">Atualizar Avatar</label>
                                <input
                                    type='file'
                                    id='avatarAtualizarOrganizacao'
                                    accept='.png, .jpeg, .jpg'
                                    onChange={(e) => avatarFile(e)}
                                    required
                                />
                                <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                    {!processando && 'Salvar Dados'}
                                    {processando && <Loader isLoading={processando} />}
                                </Button>
                            </div>
                        </form>
                    </span>
                    <form id='formDadosOrganizacao' onSubmit={atualizarDadosOrganizacao}>
                        <div id='dadosOrganizacao'>
                            <section>
                                <span>
                                    <label htmlFor="">CNPJ</label>
                                    <input
                                        type="text"
                                        value={cnpjCpf}
                                        disabled
                                    />
                                </span>
                            </section>

                            <section>
                                <span>
                                    <label htmlFor="nomeFantasiaOrganizacao">Nome Fantasia</label>
                                    <input
                                        type='text'
                                        id='nomeFantasiaOrganizacao'
                                        value={nomeFantasia === null ? '' : nomeFantasia}
                                        onChange={(e) => setNomeFantasia(e.target.value)}
                                    />
                                </span>
                                <span>
                                    <label htmlFor='razaoSocialOrganizacao'>Razão Social</label>
                                    <input
                                        type="text"
                                        id='razaoSocialOrganizacao'
                                        value={razaoSocial === null ? '' : razaoSocial}
                                        onChange={(e) => setRazaoSocial(e.target.value)}
                                    />
                                </span>
                            </section>

                            <section>
                                <span>
                                    <label htmlFor='telefoneOrganizacao'>Telefone</label>
                                    <input
                                        type="text"
                                        id='telefoneOrganizacao'
                                        placeholder="(00) 0.0000 - 0000"
                                        minLength={18}
                                        maxLength={18}
                                        value={telefone === null ? '' : telefone}
                                        onChange={(e) => changeTelefone(e)}
                                    />
                                </span>
                                <span>
                                    <label htmlFor='emailOrganizacao'>E-mail</label>
                                    <input
                                        type="email"
                                        id='emailOrganizacao'
                                        value={email === null ? '' : email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </span>

                                <span>
                                    <label htmlFor='siteOrganizacao'>Site</label>
                                    <input
                                        type="text"
                                        id='siteOrganizacao'
                                        value={site === null ? '' : site}
                                        onChange={(e) => setSite(e.target.value)}
                                    />
                                </span>
                            </section>

                            <section>
                                <span>
                                    <label htmlFor='cepOrganizacao'>CEP</label>
                                    <input
                                        type="text"
                                        id='cepOrganizacao'
                                        placeholder='0000 - 000'
                                        maxLength={11}
                                        minLength={11}
                                        value={cep === null ? '' : cep}
                                        onChange={(e) => changeCep(e)}
                                    />
                                </span>
                            </section>

                            <section>
                                <span>
                                    <label htmlFor='ruaOrganizacao'>Rua</label>
                                    <input
                                        type="text"
                                        id='ruaOrganizacao'
                                        value={rua === null ? '' : rua}
                                        onChange={(e) => setRua(e.target.value)}
                                        required
                                    />
                                </span>
                                <span>
                                    <label htmlFor='numeroOrganizacao'>Número</label>
                                    <input
                                        type="text"
                                        id='numeroOrganizacao'
                                        value={numero === null ? '' : numero}
                                        onChange={(e) => setNumero(e.target.value)}
                                    />
                                </span>
                                <span>
                                    <label htmlFor='bairroOrganizacao'>Bairro</label>
                                    <input
                                        type="text"
                                        id='bairroOrganizacao'
                                        value={bairro === null ? '' : bairro}
                                        onChange={(e) => setBairro(e.target.value)}
                                        required
                                    />
                                </span>
                                <span >
                                    <label htmlFor='complementoOrganizacao'>Complemento</label>
                                    <input
                                        type="text"
                                        id='complementoOrganizacao'
                                        value={complemento === null ? '' : complemento}
                                        onChange={(e) => setComplemento(e.target.value)}
                                    />
                                </span>
                            </section>
                            <section>
                                <span>
                                    <label htmlFor='cidadeOrganizacao'>Cidade</label>
                                    <input
                                        type="text"
                                        id='cidadeOrganizacao'
                                        value={cidade === null ? '' : cidade}
                                        disabled
                                    />
                                </span>
                                <span>
                                    <label htmlFor='estadosOrganizacao'>Estado</label>
                                    <input
                                        id='estadosOrganizacao'
                                        type="text"
                                        value={estado === null ? '' : estado}
                                        disabled
                                    />
                                </span>
                            </section>
                            <span id='btnSalvarDadosOrganizacao'>
                                <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                    {!processando && 'Salvar Dados'}
                                    {processando && <Loader isLoading={processando} />}
                                </Button>
                            </span>
                        </div>
                    </form>
                </section>
            </div>
        </Permissoes>
    );
};

export default DadosOrganizacao;